const GoOutComponent = () => import('@/views/hrm/GoOut/GoOutView')

export default [
    {
        path:'/GoOutIndex',
        name:'GoOutComponent',
        component:GoOutComponent
    }
]